// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"176":"f60b5669","215":"c6077209","328":"6107f591","807":"fa0e2f6e"}[chunkId] + ".css";
};